import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {concatMap, switchMap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';

import * as CalculatorActions from './calculator.actions';


@Injectable()
export class CalculatorEffects {


  constructor(private actions$: Actions) {
  }

}
